import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft, BarChart3, CalendarClock, Gauge, PackageX } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import apiClient from '@/services/apiClient';
import { PendingReport } from './followup/PendingReport';
import { LatePos } from './followup/LatePos';
import { UnmappedBundles } from './followup/UnmappedBundles';
import { SupplierKpis } from './followup/SupplierKpis';

const TABS = ['pending', 'late', 'unmapped', 'suppliers'];

/** PO follow-up — pending vs received by section, POs past their delivery date, bundles not counted on a PO. */
export default function POFollowUp() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const tab = TABS.includes(params.get('tab')) ? params.get('tab') : 'pending';
  const [sections, setSections] = useState([]);
  const [counts, setCounts] = useState(null);
  useEffect(() => {
    apiClient.get('/purchase-orders/sections/list').then((r) => setSections((r.data.sections || []).map((s) => s.section_name).filter(Boolean))).catch(() => {});
    apiClient.get('/po-followup/alerts').then((r) => setCounts(r.data)).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen bg-gray-50" data-testid="po-followup-page">
      <div className="bg-white border-b px-4 pt-10 pb-3 md:pt-3 flex items-center gap-3 sticky top-0 z-10">
        <Button variant="ghost" size="sm" onClick={() => navigate('/po')} data-testid="po-followup-back"><ArrowLeft className="w-4 h-4" /></Button>
        <div className="flex-1 min-w-0">
          <h1 className="text-lg font-bold text-gray-900">PO Follow-up</h1>
          <p className="text-xs text-gray-500">What each section ordered, received and is still waiting for.</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto p-4">
        <Tabs value={tab} onValueChange={(v) => setParams({ tab: v }, { replace: true })}>
          <TabsList className="mb-4 flex-wrap h-auto">
            <TabsTrigger value="pending" data-testid="po-followup-tab-pending"><BarChart3 className="w-4 h-4 mr-1.5" />Pending vs Received</TabsTrigger>
            <TabsTrigger value="late" data-testid="po-followup-tab-late"><CalendarClock className="w-4 h-4 mr-1.5" />Late deliveries{counts?.late.count ? ` (${counts.late.count})` : ''}</TabsTrigger>
            <TabsTrigger value="unmapped" data-testid="po-followup-tab-unmapped"><PackageX className="w-4 h-4 mr-1.5" />Bundles not on a PO</TabsTrigger>
            <TabsTrigger value="suppliers" data-testid="po-followup-tab-suppliers"><Gauge className="w-4 h-4 mr-1.5" />Supplier performance</TabsTrigger>
          </TabsList>
          <Card><CardContent className="pt-4">
            <TabsContent value="pending" className="mt-0"><PendingReport sections={sections} /></TabsContent>
            <TabsContent value="late" className="mt-0"><LatePos /></TabsContent>
            <TabsContent value="unmapped" className="mt-0"><UnmappedBundles /></TabsContent>
            <TabsContent value="suppliers" className="mt-0"><SupplierKpis sections={sections} /></TabsContent>
          </CardContent></Card>
        </Tabs>
      </div>
    </div>
  );
}
